var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWidgetForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2227 7H57.3216V17.8901",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5989 7H2.5V17.8592",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2227 53.3679H57.3216V42.5703",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5989 53.3679H2.5V42.5703",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9027 32.1635H42.9027V31.9412L42.8085 31.7398L41.9027 32.1635ZM46.1156 16C46.1156 15.4477 45.6678 15 45.1156 15C44.5633 15 44.1156 15.4477 44.1156 16H46.1156ZM51 41.6359C51.5523 41.6359 52 41.1882 52 40.6359C52 40.0836 51.5523 39.6359 51 39.6359V41.6359ZM31.5315 28.1462L30.681 28.6722L31.5315 28.1462ZM33.2365 30.9029L34.087 30.3769L33.2365 30.9029ZM42.8085 31.7398L35.9656 17.1092L34.154 17.9565L40.9968 32.5872L42.8085 31.7398ZM32.6507 15H24.924V17H32.6507V15ZM21.2644 18.6596V26.8856H23.2644V18.6596H21.2644ZM20 40.6359V29.5452H18V40.6359H20ZM21.6596 27.8856H29.2696V25.8856H21.6596V27.8856ZM30.681 28.6722L32.3861 31.429L34.087 30.3769L32.3819 27.6201L30.681 28.6722ZM35.4984 33.1635H41.9027V31.1635H35.4984V33.1635ZM42.9027 40.2626V38.3962H40.9027V40.2626H42.9027ZM47.7751 41.6359H51V39.6359H47.7751V41.6359ZM24.9104 41.6359H35.9923V39.6359H24.9104V41.6359ZM42.9027 38.3962V36.2105H40.9027V38.3962H42.9027ZM42.9027 36.2105V32.1635H40.9027V36.2105H42.9027ZM44.1156 16V36.2105H46.1156V16H44.1156ZM44.1156 36.2105V37.9763H46.1156V36.2105H44.1156ZM41.9027 37.2105H45.1156V35.2105H41.9027V37.2105ZM47.7751 39.6359C46.8586 39.6359 46.1156 38.8929 46.1156 37.9763H44.1156C44.1156 39.9974 45.754 41.6359 47.7751 41.6359V39.6359ZM29.2696 27.8856C29.8445 27.8856 30.3785 28.1832 30.681 28.6722L32.3819 27.6201C31.715 26.5419 30.5375 25.8856 29.2696 25.8856V27.8856ZM20 29.5452C20 28.6286 20.743 27.8856 21.6596 27.8856V25.8856C19.6384 25.8856 18 27.5241 18 29.5452H20ZM24.924 15C22.9029 15 21.2644 16.6384 21.2644 18.6596H23.2644C23.2644 17.743 24.0075 17 24.924 17V15ZM32.3861 31.429C33.053 32.5072 34.2305 33.1635 35.4984 33.1635V31.1635C34.9235 31.1635 34.3895 30.8659 34.087 30.3769L32.3861 31.429ZM35.9656 17.1092C35.3637 15.8223 34.0714 15 32.6507 15V17C33.295 17 33.881 17.3729 34.154 17.9565L35.9656 17.1092Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9552,
    cy: 40.6366,
    rx: 2.95518,
    ry: 2.98617,
    stroke: "white",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.9435,
    cy: 40.6366,
    rx: 2.95518,
    ry: 2.98617,
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 35L11.5 35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31L8.5 31",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWidgetForklift);
export default __webpack_public_path__ + "static/media/icon-widget-forklift.e102b9f7cd352e9b413118c1324bdf76.svg";
export { ForwardRef as ReactComponent };